import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import FormikForm from "../components/commonForm";
import InputComponents from "../components/input";
import AppLayout from "../components/AppLayout";
import { feildsCategories, initialValuesCategories, validationSchemaCategories } from "../fromsUtil/categories.from";
import { addCategories, updateCategories } from "../logic/categories/action";
import { failedCategories, failedPresets } from "../logic/categories/reducer";

const AddCategory = () => {
  const dispatch = useDispatch();
  const selector = useSelector(state=>state.categories);
  const [data, setdata] = useState({
    business_type:'',customer_alias:'',staff_alias:''
  });
  
  const nav = useNavigate();

  const onSubmit = async(values,submitProps)=>{
    await addCategories(dispatch,values,nav);
    submitProps.setSubmitting(true);
    submitProps.resetForm();
  }

  return (
    <AppLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex-1 h-full flex flex-col items-center gap-8 p-6 md:p-10 justify-center"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
          className="w-full max-w-2xl"
        >
          <div className="bg-white/80 backdrop-blur-xl rounded-2xl shadow-xl border border-white/20 p-8 md:p-10">
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-3xl md:text-4xl font-bold text-center mb-2 bg-gradient-to-r from-purple-600 via-pink-500 to-blue-600 bg-clip-text text-transparent"
            >
              Add New Category
            </motion.h1>
            <p className="text-center text-gray-600 mb-8">Fill in the details to create a new category</p>
            <FormikForm
              initialValues={initialValuesCategories}
              fields={feildsCategories}
              validationSchema={validationSchemaCategories}
              action={(disabled) => (
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  disabled={disabled}
                  className="w-full bg-gradient-to-r from-[#667eea] to-[#764ba2] text-white font-bold py-4 rounded-xl text-lg shadow-lg hover:shadow-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                  type="submit"
                >
                  {disabled ? 'Adding...' : 'Add Category'}
                </motion.button>
              )}
              onSubmit={onSubmit}
            />

            {selector.error && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                className="mt-4 p-4 bg-red-50 border border-red-200 rounded-xl"
              >
                <p className="text-red-600 text-center">{selector.errorMessage}</p>
              </motion.div>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AppLayout>
  );
};

export default AddCategory;
